import "url-polyfill";
import Vue from "vue/dist/vue.esm";
import VueI18n from "vue-i18n";
import events from "/events";
import Smartbanner from "/features/smartbanner/components/smartbanner";
import getLocale from "/utils/locale";
import { os as getOs } from "/utils/user-agent";
import cookie from "/utils/cookie";
import {
  init as initAdjust,
  adjustUrl
} from "/utils/adjust-links";
import globals from "/utils/globals";

Vue.use(VueI18n);

const os = getOs();
const COOKIE_NAME = "sb-closed";
const COOKIE_LIFE_TIME = 30;
const PIWIK_EVENT_CATEGORY = "header-20190405-smartbanner";
const blackListedPageClasses = [
  "body.landing_pages__show",
  "body.purchase"
];

initAdjust();

const init = config => {

  if (["ios", "android"].indexOf(os) < 0) {
    return;
  }

  if (cookie(COOKIE_NAME)) {
    return;
  }

  if (document.querySelector(blackListedPageClasses.join(","))) {
    return;
  }

  if (!globals.smartbanner) {
    return;
  }

  const el = document.getElementById("smartbanner");

  if (!el) {
    return;
  }

  const storeLink = adjustUrl(PIWIK_EVENT_CATEGORY, null, config.test_categories, config.fingerprint);
  const platform = os;

  new Vue({
    el,
    i18n: new VueI18n({ locale: getLocale() }),
    render(h) {
      return h(Smartbanner, {
        props: {
          platform,
          rating: globals.smartbanner.rating[os].stars,
          ratingsCount: globals.smartbanner.rating[os].count,
          storeLink,
          onClose: () => {
            cookie(COOKIE_NAME, true, { expires: COOKIE_LIFE_TIME });
            events.track(PIWIK_EVENT_CATEGORY, "close");
            events.emit("smartbanner:close");
          }
        }
      });
    }
  });
};

events.on("setup:ready", init);
